"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addParamsToUrl = void 0;
const addParamsToUrl = ({
  url: path,
  params = {}
}) => {
  const [baseUrl, queryString = ''] = path.split('?');
  const urlParams = new URLSearchParams(queryString);
  Object.entries(params).forEach(([key, value]) => {
    urlParams.set(key, encodeURIComponent(value));
  });
  return `${baseUrl}?${urlParams.toString()}`;
};
exports.addParamsToUrl = addParamsToUrl;
